import React from 'react'
import ContactLayout from '../../layout/Contact/Contact'
import './Contact.css'
const Contact = () => {
  return (
    <div className='contact-me-page'>
      <ContactLayout/>
    </div>
  )
}

export default Contact
